import { getAxiosBackendApi } from "../helpers/axios"

class MartyrServices{

    constructor(){
    }

    addMartyr(data){
        return getAxiosBackendApi().post('martyrs', data)
    }

    addMartyrWithoutCode(data){
        return getAxiosBackendApi().post('martyrs-without-code', data)
    }
}

export default new MartyrServices()